/* PAR CUSTOM · animated header logo v4 "bounce, struggle, then the whole catalog" (2026-07-21).
   The cycle (owner-directed):
   - LOGO (long): the PAR logo hangs out, wandering AND playing — little cartoon hops with
     squash-and-stretch, like a bouncing ball with a personality.
   - TRY: it strains to transform — two visible failed bulges + a tremble...
   - ...then it MAKES IT, and once it's going it KEEPS going: it chains through ALL TEN products
     quickly (fast product→product morphs, each shown ~0.8s), no going back to the logo between them.
   - BACK: after the last product it relaxes into the logo and rests (the logo gets the longest time).
   Products: vent cover, filter cover (frame + lattice door), range hood, dovetail drawer box,
   cutting board, wine cabinet, kitchen door, cabinet, furniture dresser, fast-shipping box.
   Pauses off-screen; reduced-motion = static logo; keeps home link + size.
   Loaded from layout/theme.liquid. Source of truth: repo par-logo-anim.js. */
(function(){
  function boot(){
    var img=document.querySelector("img.header__heading-logo");
    if(!img || img.__parAnim) return; img.__parAnim=1;
    if(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var logoUrl=null;
    try{ var c=getComputedStyle(img).content||""; var m=c.match(/url\(["']?([^"')]+)["']?\)/); if(m) logoUrl=m[1]; }catch(e){}
    if(!logoUrl) logoUrl=img.currentSrc||img.src;
    var w=img.clientWidth||img.width||90;
    var box=document.createElement("span");
    box.style.cssText="display:inline-block;width:"+w+"px;height:"+w+"px;vertical-align:middle;line-height:0";
    box.innerHTML=
      '<svg viewBox="0 0 120 120" style="width:100%;height:100%;display:block;overflow:visible">'
      +'<g class="parHG">'
      +'<path class="parHM" fill="#faf8f4" stroke="#151312" stroke-width="2.6" stroke-linejoin="round"/>'
      +'<g class="parHD" style="opacity:1;transition:opacity .25s ease"><image href="'+logoUrl+'" x="14" y="14" width="92" height="92"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<rect x="27" y="40" width="6" height="40" rx="2" fill="#a67c3d"/><rect x="39" y="40" width="6" height="40" rx="2" fill="#a67c3d"/>'
      +  '<rect x="51" y="40" width="6" height="40" rx="2" fill="#a67c3d"/><rect x="63" y="40" width="6" height="40" rx="2" fill="#a67c3d"/>'
      +  '<rect x="75" y="40" width="6" height="40" rx="2" fill="#a67c3d"/><rect x="87" y="40" width="6" height="40" rx="2" fill="#a67c3d"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<rect x="32" y="32" width="56" height="56" rx="4" fill="none" stroke="#151312" stroke-width="2"/>'
      +  '<line x1="40" y1="46" x2="74" y2="80" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/>'
      +  '<line x1="46" y1="40" x2="80" y2="74" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/>'
      +  '<line x1="40" y1="74" x2="74" y2="40" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/>'
      +  '<line x1="46" y1="80" x2="80" y2="46" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<line x1="22" y1="92" x2="98" y2="92" stroke="#151312" stroke-width="2.5"/>'
      +  '<line x1="44" y1="40" x2="76" y2="40" stroke="#151312" stroke-width="2"/>'
      +  '<circle cx="60" cy="72" r="4" fill="#a67c3d"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<path d="M36 40 L44 46 L36 52 L44 58 L36 64 L44 70 L36 76" fill="none" stroke="#a67c3d" stroke-width="2.5" stroke-linejoin="round"/>'
      +  '<path d="M84 40 L76 46 L84 52 L76 58 L84 64 L76 70 L84 76" fill="none" stroke="#a67c3d" stroke-width="2.5" stroke-linejoin="round"/>'
      +  '<rect x="52" y="38" width="16" height="5" rx="2.5" fill="#151312"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<circle cx="28" cy="60" r="4.5" fill="none" stroke="#151312" stroke-width="2.5"/>'
      +  '<line x1="44" y1="52" x2="96" y2="52" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/>'
      +  '<line x1="44" y1="62" x2="96" y2="62" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/>'
      +  '<line x1="44" y1="72" x2="92" y2="72" stroke="#a67c3d" stroke-width="2" stroke-linecap="round"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<line x1="34" y1="64" x2="86" y2="96" stroke="#151312" stroke-width="2.2"/>'
      +  '<line x1="86" y1="64" x2="34" y2="96" stroke="#151312" stroke-width="2.2"/>'
      +  '<circle cx="46" cy="44" r="4" fill="#a67c3d"/><circle cx="60" cy="40" r="4" fill="#a67c3d"/><circle cx="74" cy="44" r="4" fill="#a67c3d"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<rect x="38" y="22" width="44" height="76" rx="2" fill="none" stroke="#151312" stroke-width="2.2"/>'
      +  '<circle cx="76" cy="60" r="2.8" fill="#a67c3d"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<line x1="60" y1="16" x2="60" y2="104" stroke="#151312" stroke-width="2.2"/>'
      +  '<circle cx="52.5" cy="60" r="2.6" fill="#a67c3d"/><circle cx="67.5" cy="60" r="2.6" fill="#a67c3d"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<line x1="36" y1="47" x2="84" y2="47" stroke="#151312" stroke-width="2"/>'
      +  '<line x1="36" y1="72" x2="84" y2="72" stroke="#151312" stroke-width="2"/>'
      +  '<circle cx="60" cy="35" r="2.4" fill="#a67c3d"/><circle cx="60" cy="60" r="2.4" fill="#a67c3d"/><circle cx="60" cy="85" r="2.4" fill="#a67c3d"/>'
      +  '<rect x="34" y="96" width="6" height="9" rx="1.5" fill="#151312"/><rect x="80" y="96" width="6" height="9" rx="1.5" fill="#151312"/></g>'
      +'<g class="parHD" style="opacity:0;transition:opacity .25s ease">'
      +  '<path d="M40 22 L60 36 L80 22" fill="none" stroke="#151312" stroke-width="2"/>'
      +  '<line x1="60" y1="36" x2="60" y2="58" stroke="#151312" stroke-width="2.5"/>'
      +  '<line x1="0" y1="46" x2="18" y2="46" stroke="#a67c3d" stroke-width="3" stroke-linecap="round"/>'
      +  '<line x1="6" y1="60" x2="22" y2="60" stroke="#a67c3d" stroke-width="3" stroke-linecap="round"/>'
      +  '<line x1="0" y1="74" x2="18" y2="74" stroke="#a67c3d" stroke-width="3" stroke-linecap="round"/></g>'
      +'</g></svg>';
    img.style.display="none";
    img.parentNode.insertBefore(box,img);
    var grp=box.querySelector(".parHG");
    var path=box.querySelector(".parHM");
    var dets=[].slice.call(box.querySelectorAll(".parHD"));

    var N=72,TAU=Math.PI*2;
    function superR(a,b,n){ return function(th){ var c=Math.abs(Math.cos(th))/a,s=Math.abs(Math.sin(th))/b;
      return Math.pow(Math.pow(c,n)+Math.pow(s,n),-1/n); }; }
    function polyR(pts){ return function(th){ var dx=Math.cos(th),dy=Math.sin(th),best=1e9;
      for(var i=0;i<pts.length;i++){ var a=pts[i],b=pts[(i+1)%pts.length];
        var ex=b[0]-a[0],ey=b[1]-a[1],den=dx*ey-dy*ex; if(Math.abs(den)<1e-9)continue;
        var t=(a[0]*ey-a[1]*ex)/den; if(t<=0)continue;
        var u=Math.abs(ex)>Math.abs(ey)?(dx*t-a[0])/ex:(dy*t-a[1])/ey;
        if(u>=-0.001&&u<=1.001&&t<best)best=t; }
      return best===1e9?50:best; }; }
    function archR(a,hb,ch){ return function(th){ var dx=Math.cos(th),dy=Math.sin(th),cands=[];
      if(dy>1e-6){ var t1=hb/dy; if(Math.abs(dx*t1)<=a+0.5) cands.push(t1); }
      if(Math.abs(dx)>1e-6){ var t2=a/Math.abs(dx); var y2=dy*t2; if(y2<=hb+0.5&&y2>=-ch-0.5) cands.push(t2); }
      var dot=dy*(-ch), disc=dot*dot-(ch*ch-a*a);
      if(disc>0){ var t3=dot+Math.sqrt(disc); if(t3>0 && dy*t3<=-ch+0.5) cands.push(t3); }
      return cands.length?Math.min.apply(null,cands):50; }; }
    var hood=[[-52,46],[52,46],[16,-20],[16,-48],[-16,-48],[-16,-20]];
    var shapes=[ superR(50,50,2), superR(52,36,6), superR(46,46,8), polyR(hood), superR(52,34,7),
                 superR(52,32,3.2), archR(38,50,14), superR(34,52,10), superR(42,50,9),
                 superR(48,38,8), superR(40,40,6) ];
    var radii=shapes.map(function(f){ var r=[],i; for(i=0;i<N;i++)r.push(f(i/N*TAU)); return r; });
    function pathOf(r0,r1,k){ var d="",i; for(i=0;i<N;i++){ var th=i/N*TAU,r=r0[i]+(r1[i]-r0[i])*k;
      d+=(i?"L":"M")+(60+r*Math.cos(th)).toFixed(1)+" "+(60+r*Math.sin(th)).toFixed(1); } return d+"Z"; }
    path.setAttribute("d",pathOf(radii[0],radii[0],0));

    /* ---- segment timeline: one long playful logo rest, one struggle, then chain ALL products fast */
    var P=shapes.length-1;                 // 10 products
    var LOGO=5500, TRY=1500, GO=600, SHOWF=780, MORPHF=420, BACK=600;
    var segs=[{k:"logo",d:LOGO},{k:"try",d:TRY},{k:"go",d:GO,a:0,b:1}];
    for(var p=1;p<=P;p++){ segs.push({k:"show",d:SHOWF,a:p});
      if(p<P) segs.push({k:"mf",d:MORPHF,a:p,b:p+1}); }
    segs.push({k:"back",d:BACK,a:P,b:0});
    var CYCLE=0; for(var i2=0;i2<segs.length;i2++){ segs[i2].t0=CYCLE; CYCLE+=segs[i2].d; }
    function easeB(t){ var s=1.15,u; if(t<0.5){ u=2*t; return (u*u*((s+1)*u-s))/2; }
      u=2*t-2; return (u*u*((s+1)*u+s)+2)/2; }
    function tryF(u){                       // two failed bulges + tremble
      if(u<450) return 0.32*Math.sin(Math.PI*(u/450));
      if(u<600) return 0;
      if(u<1100) return 0.52*Math.sin(Math.PI*((u-600)/500));
      return 0.05*Math.abs(Math.sin(u*0.05));
    }
    var vis=true;
    if("IntersectionObserver" in window){ new IntersectionObserver(function(es){ vis=es[0].isIntersecting; }).observe(box); }
    var t0=performance.now();
    function tick(now){ requestAnimationFrame(tick); if(!vis)return;
      var T=now-t0, t=T%CYCLE, seg=segs[0], i;
      for(i=segs.length-1;i>=0;i--){ if(t>=segs[i].t0){ seg=segs[i]; break; } }
      var lt=t-seg.t0, u=lt/seg.d;
      var rA=radii[0], rB=radii[0], f=0, act=0, rot=0, tx=0, ty=0, sx=1, sy=1;
      if(seg.k==="logo"){
        act=0;
        tx=3.2*Math.sin(T*0.0011); rot=2.5*Math.sin(T*0.0008);      // wandering/pacing
        var hopP=(lt%2400)/2400;                                    // playful hop every 2.4s
        if(hopP<0.32){ var h=hopP/0.32;
          ty=-11*Math.sin(Math.PI*h);                               // the hop
          sy=1+0.10*Math.sin(Math.PI*h); sx=1-0.06*Math.sin(Math.PI*h);   // stretch in the air
          if(h>0.86||h<0.10){ sy=0.90; sx=1.09; ty=ty*0.4; }        // squash on takeoff + landing
        } else { ty=2.0*Math.sin(T*0.0016+1.3); }                   // gentle sway between hops
      } else if(seg.k==="try"){
        act=0; rA=radii[0]; rB=radii[1]; f=tryF(lt);                // straining toward the FIRST product
        rot=(f>0.02?5:1.6)*Math.sin(lt*0.11); sx=sy=1+0.02*f;
      } else if(seg.k==="go"){
        rA=radii[0]; rB=radii[1]; f=easeB(u);
        rot=9*Math.sin(Math.PI*u); sx=sy=1+0.05*Math.sin(Math.PI*u);
        act=(f>0.85)?1:-1;
      } else if(seg.k==="show"){
        rA=radii[seg.a]; rB=radii[seg.a]; f=0; act=seg.a;
        rot=2*Math.sin(lt*0.012); sx=sy=1+0.012*Math.sin(lt*0.008);
      } else if(seg.k==="mf"){                                      // fast product→product hop
        rA=radii[seg.a]; rB=radii[seg.b]; f=easeB(u);
        rot=(seg.a%2?-6:6)*Math.sin(Math.PI*u); sx=sy=1+0.035*Math.sin(Math.PI*u);
        act=(f>0.8)?seg.b:-1;
      } else {                                                      // back — relax into the logo
        rA=radii[seg.a]; rB=radii[0]; f=easeB(u);
        rot=4*Math.sin(Math.PI*u);
        act=(f>0.8)?0:-1;
      }
      path.setAttribute("d",pathOf(rA,rB,f));
      grp.setAttribute("transform","translate("+(60+tx)+" "+(60+ty)+") scale("+sx.toFixed(3)+" "+sy.toFixed(3)+") rotate("+rot.toFixed(2)+") translate(-60 -60)");
      for(i=0;i<dets.length;i++)dets[i].style.opacity=(i===act)?"1":"0"; }
    requestAnimationFrame(tick);
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",boot); else boot();
  document.addEventListener("shopify:section:load",function(){ setTimeout(boot,60); });
})();
